var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('attachment-default-component',{attrs:{"attachments":_vm.getAttachments,"hide-actions":_vm.$permissionAccess.isBroker,"componentDialog":_vm.attachmentsDialog,"attachment-service":_vm.enterpriseAttachmentService},on:{"change":_vm.reloadData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }